import {Select} from '@mantine/core';
import type {FC} from 'react';
import {useCallback, useMemo} from 'react';
import {ModalCancelButton} from '../ModalCancelButton';
import {ModalSubmitButton} from '../ModalSubmitButton';

type Props = {
  onClose: () => void;
  onSubmit: () => void;
  companyId: number;
  onCompanySelect: (id: number, name: string) => void;
  companyList: {id: number; value: string}[];
};

export const AiTodoCompanySelectContent: FC<Props> = ({
  onClose,
  onSubmit,
  companyId,
  onCompanySelect,
  companyList,
}) => {
  const selectData = useMemo(
    () =>
      companyList.map((company) => ({
        value: String(company.id),
        label: company.value,
      })),
    [companyList],
  );

  const selectedValue = useMemo(() => {
    return companyId > 0 ? String(companyId) : null;
  }, [companyId]);

  const handleChange = useCallback(
    (value: string | null) => {
      if (value) {
        const company = companyList.find((c) => String(c.id) === value);
        if (company) {
          onCompanySelect(company.id, company.value);
        }
      }
    },
    [companyList, onCompanySelect],
  );

  return (
    <div className="flex flex-col gap-24">
      <div className="flex flex-col gap-8">
        <Select
          label="企業名"
          value={selectedValue}
          onChange={handleChange}
          placeholder="企業名を選択してください"
          data={selectData}
          maxDropdownHeight={320}
          radius={24}
          withinPortal
          searchable
        />
      </div>
      <div className="flex items-center justify-center gap-16">
        <ModalCancelButton onClick={onClose}>キャンセル</ModalCancelButton>
        <ModalSubmitButton onClick={onSubmit} disabled={companyId <= 0}>
          次へ
        </ModalSubmitButton>
      </div>
    </div>
  );
};
